<template>

</template>

<script>
  export default {
    name: 'logout',

    mounted () {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Logout.vue